module.exports = __webpack_public_path__ + "static/media/StatUsesCircle.d79ab820.svg";